import { OnInit, Directive } from '@angular/core';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';
import { BaseHttpService, UriBuilderParams, Update } from '@app/core/services/base/base-http.service';
import { BaseWithId } from '@app/shared/models/base';
import { BaseChangeComponent } from '@app/shared/components/base/base-change.component';

@Directive()
export abstract class BaseUpdateComponent<T extends BaseWithId, U extends UriBuilderParams<T>> extends BaseChangeComponent<T, U>
                                                                                               implements OnInit {

    protected constructor(protected componentServiceBundle: ComponentServiceBundle,
                          protected drHttpService: BaseHttpService<T, U> & Update<T, U>) {
        super(componentServiceBundle, drHttpService);
    }

    public ngOnInit() {
        super.ngOnInit();
    }

    public update(propOverride?: string, callbackFn?: Function, errorCallbackFn?: Function, externalToUpdate?: T): void {
        this.formToModel();
        const uriParams = this.generateUriBuilderParams();
        this.drHttpService.update(uriParams, (externalToUpdate ? externalToUpdate : this.updated), this.patchParams, propOverride)
                          .subscribe((result: T) => {
                   this.afterChange(result, callbackFn);
                }, err => {
                    this.handleError(err);

                    if (errorCallbackFn) {
                        errorCallbackFn();
                    }
                }
            );
    }

    public formToModel(): void {
        // override me if needed
    }

}
